import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NGXLogger } from 'ngx-logger';
import { environment } from 'src/environments/environment';
import { HkDrBcpAck } from './dr-bcp-ack.model';
import { Observable, catchError, map, of, throwError } from 'rxjs';
import { showErrorDialog, showSuccessSnackbar } from 'src/app/shared/utils';

@Injectable({
  providedIn: 'root'
})
export class HkDrBcpAcksService {
  private apiEndpoint = `${environment.apiEndpoint}/api/hk/dr-bcp-acks`;

  constructor(
    private http: HttpClient,
    private logger: NGXLogger,
    public apiErrorDialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  getMine$(): Observable<HkDrBcpAck | null> {
    return this.http.get<HkDrBcpAck>(`${this.apiEndpoint}/me`).pipe(catchError(() => of(null)));
  }

  acknowledge$(readingTimeMs: number): Observable<void> {
    return this.http
      .post(`${this.apiEndpoint}/ack`, null, {
        params: {
          readingTimeMs: readingTimeMs.toString()
        },
        responseType: 'text'
      })
      .pipe(
        map(() => showSuccessSnackbar(this.snackBar, 'Your acknowledgement was successfully recorded')),
        catchError((error: any) => {
          this.logger.error(error);
          showErrorDialog(this.apiErrorDialog, error);
          return throwError(() => new Error(error));
        })
      );
  }
}
